// extracted by mini-css-extract-plugin
export default {"Container":"Cards_Container__VQAMS","Cards-wrapper":"Cards_Cards-wrapper__C1QaO","card":"Cards_card__tsc2I","icon-wrapper":"Cards_icon-wrapper__vMN-W"};